export { default as moveIntoCave } from "./moveIntoCave";
